<div class="master-form p-0" style="border-radius: 5px;" *ngIf="emergencyTransformers ==1" [hidden]="risFlag==1">
  <app-fast-search [appearFastSearch]="false" [emitSearchAfterInt]="true" [appCodes]="[1023,1040,2005,2006]"
    name="fastSearchData" ngDefaultControl (searchKeys)="onSearchClick($event)"></app-fast-search>
</div>

<div *ngIf="emergencyTransformers !=1" [hidden]="risFlag==1 || fromWhere=='radioGrapher'">
  <div class="row mx-0" *ngIf="!notPayedPatientsFlag ">
    <div class="col-3 mb-3" *ngIf="_showPatFlag">
      <sanabel-selectize appcode="1023" #Patients (clicked)="getPatienTvisit($event)">
      </sanabel-selectize>
    </div>
    <div class="col-3 mb-2">
      <sanabel-selectize appcode="1016" #parentServiceSelectize [(ngModel)]="speciality"
        (clicked)="onSpecialSelected($event)">
      </sanabel-selectize>
    </div>
    <div class="col-2 mb-2">
      <sanabel-selectize (clicked)="getVisitSerial($event)" [forceRefreshEverySearch]="true"
        [SearchKeys]="{PatCode : patFromInputs?.patCode,speciality:speciality}" [appcode]="1096" #visitSerial>
      </sanabel-selectize>
    </div>
    <div class="col-2">
      <sanabel-selectize [appcode]="1061" [(ngModel)]="serviceCode">
      </sanabel-selectize>
    </div>
    <div class="col-2">
      <sanabel-selectize [appcode]="5" [(ngModel)]="serviceType" [multi]="true">
      </sanabel-selectize>
    </div>
    <div class="col-2" style="padding-top: 30px;">
      <label class="custom-control custom-checkbox">
        <input type="checkbox" class="custom-control-input" [(ngModel)]="allVisits" #statusCheckBox>
        <span class="custom-control-description">{{ 'ALLVISITIS' | translate }}</span>
      </label>
    </div>
    <div class="col-1 mt-3 align-self-center">
      <button class="btn btn-danger fa fa-search fa-lg" (click)="patServicesLoad()"></button>
    </div>
  </div>
</div>
<div class="col-md-12">
  <breadcrumb (clicked)="onBreadCrumbClick($event)" [data]="breadCrumbData"></breadcrumb>
  <div class="row" *ngIf="activeAction == 0 || visitedActions['0'] " [hidden]="activeAction != 0">
    <div class="col">
      <p-dataTable tableStyleClass="table table-bordered table-striped" [rowStyleClass]="getCSSClasses"
        [value]="patServices" [selectionMode]="'single'" [rows]="10" [paginator]="true" [pageLinks]="3"
        [rowsPerPageOptions]="[15,20,25,30]" rowGroupMode="subheader" groupField="serviceType"
        (onRowClick)="onRowSelect($event)">
        <!------------------------------ details ------------------------------------------------>
        <ng-template pTemplate="rowgroupheader" let-row>
          {{translate.currentLang == 'ar' ? row['serviceTypeNameAr']:row['serviceTypeNameEn']}}</ng-template>
        <p-column field="customServiceCode" [style]="{'width': '5%'}" header="{{ 'SERVICECODE' | translate  }}">
        </p-column>
        <p-column field="regPatServiceSerial" [style]="{'width': '5%'}" header="{{ 'Acession Number	' | translate  }}">
        </p-column>
        <p-column field="count" header="{{ 'COUNT' | translate  }}"></p-column>
        <p-column field="{{translate.currentLang == 'ar' ? 'serviceNameAr':'serviceNameEn'}}"
          header="{{ 'SERVICENAME' | translate  }}" [style]="{'width': '12%'}"></p-column>
        <p-column field="sessionSort" header="{{ 'SESSIONNO' | translate  }}"></p-column>
        <p-column [style]="{'width': '5%'}" header="{{ 'ServiceStatus' | translate }}">
          <ng-template pTemplate="options" let-row="rowData">
            <span *ngIf="row.servStatus == 13; else notWrite">
              <span *ngIf="row.abnormality == 1">Abnormal</span>
              <span *ngIf="row.abnormality == 0">Normal</span>
            </span>
            <ng-template #notWrite>
              <!-- {{translate.currentLang == 'ar' ? row['serviceStatusAr'] : row['serviceStatusEn'] }} -->
              {{translate.currentLang == 'ar' ? row['serviceStatusDoneAr'] : row['serviceStatusDoneEn'] }}
            </ng-template>
          </ng-template>
        </p-column>
        <p-column field="{{translate.currentLang == 'ar' ? 'docNameAr':'docNameEn'}}"
          header="{{ 'DOCTOR' | translate  }}" [style]="{'width': '10%'}"></p-column>
        <p-column field="{{translate.currentLang == 'ar' ? 'bodyPartNameAr':'bodyPartNameEn'}}"
          header="{{ 'BODYPART' | translate  }}" [style]="{'width': '10%'}"></p-column>
        <p-column field="{{translate.currentLang == 'ar' ? 'inTransferBodiesAr': 'inTransferBodiesEn'}}"
          header="{{ 'COMINGFROM' | translate  }}" [style]="{'width': '12%'}"></p-column>
        <p-column field="{{translate.currentLang == 'ar' ? 'contractsAr': 'contractsEn'}}"
          header="{{ 'CONTRACTNAME' | translate  }}" [style]="{'width': '8%'}"></p-column>

        <p-column field="expectedStartTime" [style]="{'width': '8%'}" header="{{ 'DATETIME' | translate }}"
          [sortable]="true"></p-column>
        <p-column field="payed" header="{{'Payed' | translate }}" [style]="{'width': '4%'}">
          <ng-template pTemplate="options" let-row="rowData">
            <!-- <i *ngIf="row['payed'] == 1" class="fa fa-check fa-2x" aria-hidden="true"></i> -->
            <i [ngClass]="{'dollar-color':row['payed'] != null,'emergant-level':(row['payed'] == null||row['payed'] == -1)}"
              class="fa fa-money fa-xl" aria-hidden="true"></i>
          </ng-template>
        </p-column>
        <p-column *ngIf="this.showprice==1" field="servicePrice" [style]="{'width': '5%'}"
          header="{{ 'Price' | translate  }}">
        </p-column>
        <p-column *ngIf="this.showprice==1" field="remainingPrice" header="{{ 'REMAININGVALUE' | translate  }}"
          [style]="{'width': '5%'}">
        </p-column>
        <p-column *ngIf="this.showprice==1" field="patPrice" header="{{ 'PATPRICE' | translate  }}"
          [style]="{'width': '5%'}">

        </p-column>
        <p-column *ngIf="this.showprice==1" field="payedValue" header="{{ 'Payed' | translate  }}"
          [style]="{'width': '5%'}"></p-column>
        <!-- حالة التقرير -->
        <p-column [sortable]="true" [style]="{'width': '8%'}" header="{{ 'REPORTSSTATUS' | translate }}">
          <ng-template pTemplate="options" let-row="rowData">
            <span>
              {{translate.currentLang=='ar'?row.reportStatusAr:row.reportStatusEn}}
            </span>
          </ng-template>
        </p-column>
        <!-- مرحله التسليم  -->
        <p-column [sortable]="true" [style]="{'width': '8%'}" header="{{ 'DELIVERYSTEP' | translate }}">
          <ng-template pTemplate="options" let-row="rowData">
            <div>
              <span>
                {{translate.currentLang=='ar'?row.deliveryStepAr:row.deliveryStepEn}}
              </span>
              <!-- (click)="exortReportAsWord(row)" -->
              <i class="fa fa-file-word-o" aria-hidden="true" style="font-size: 22px;color: blue;cursor: pointer;"
                *ngIf="row['reportStatus']==19 || row['reportStatus']==18 || row['reportStatus']==61"
                (click)="exortReportAsWord(row)">
              </i>
            </div>
          </ng-template>
        </p-column>
        <!-- field="{{translate.currentLang == 'ar' ? 'approvalReasonNameAr':'approvalReasonNameEn'}}" -->
        <!-- ({{translate.currentLang == 'ar' ?  row['approvalReasonNameAr']: row['approvalReasonNameEn']}}) -->
        <p-column *ngIf="notPayedPatientsFlag" header="{{ 'APPROVAL' | translate  }}" [style]="{'width': '8%'}">

          <ng-template pTemplate="options" let-row="rowData">

            <span *ngIf="row.approvalStatus == 1" class="mx-3 text-success">({{'ACCEPTED'| translate
              }})</span>
            <span *ngIf="row.approvalStatus == 2" class="mx-3 text-danger">({{'REJECTED' | translate
              }})</span>
            <span *ngIf="row.approvalStatus == 3" class="mx-3 text-info">({{'PENDING' | translate }})</span>
            <span *ngIf="row.approvalStatus == 4" class="mx-3 text-info">({{'PENDING' | translate }})</span>
            <!-- <span *ngIf="row.approvalStatus == 4" class="mx-3 text-success">({{'Dispensed' | translate }})</span> -->
          </ng-template>
        </p-column>
        <p-column field="notes1" header="{{ 'Notes' | translate  }}" [style]="{'width': '10%'}"></p-column>
        <p-column field="{{translate.currentLang == 'ar' ? 'palceAr':'palceEn'}}"
          header="{{ 'CLINICNAMEAR' | translate  }}" [style]="{'width': '10%'}"></p-column>
        <p-column styleClass="col-button" field="toothNo" header="{{ 'ToothNo' | translate }}">

        </p-column>
        <p-column *ngIf="!notPayedPatientsFlag" [hidden]="fromWhere=='radioGrapher'" [style]="{'width': '5%'}"
          header="{{ 'ACTIONS' | translate }}">
          <ng-template pTemplate="options" let-row="rowData">
            <span class="" *ngIf="row.serviceStatusCode != 5">
              <icon-action (actionclicked)="onIconActionClick($event,row)" [rowActiveAction]="getActiveAction"
                [rowData]="row"
                [appCodes]="[689,681,682,2326,2154,306,2493,2293,2325,2472,637,304,6387,6765,7170,7286]"></icon-action>
            </span>
          </ng-template>
        </p-column>

        <p-column [hidden]="fromWhere=='radioGrapher'" styleClass="col-button" header="{{ 'ACTION' | translate }}">
          <ng-template pTemplate="options" let-row="rowData">
            <span>
              <icon-action (clicked)="getServiceDiscount(row)" [appCodes]="[404]">
              </icon-action>
            </span>
          </ng-template>
        </p-column>

      </p-dataTable>
    </div>
  </div>

  <div class="" *ngIf="activeAction == 0 || visitedActions['0'] " [hidden]="activeAction != 0">
    <!-- <h3 *ngIf="historyData.length > 0" class="text-center text-danger font-weight-bold mt-4 mb-2">
      {{'BLOODBANK' | translate}}</h3>
    <div class="row" *ngIf="historyData.length > 0">
      <div class="col">
        <p-dataTable tableStyleClass="table table-bordered table-striped" [rowStyleClass]="getCSSClasses"
          [value]="historyData" [selectionMode]="'single'" [rows]="15" [paginator]="true" [pageLinks]="3"
          [rowsPerPageOptions]="[15,20,25,30]">
          <p-column field="itemCode" [style]="{'width': '7%'}" header="{{ 'ITEMCODE' | translate  }}">
          </p-column>
          <p-column field="{{translate.currentLang == 'ar' ? 'itemNameAr': 'itemNameEn'}}"
            header="{{ 'ITEM' | translate  }}">
          </p-column>
          <p-column field="qty" [style]="{'width': '15%'}" header="{{ 'QUANTITY' | translate }}"></p-column>
          <p-column field="{{translate.currentLang == 'ar' ? 'storeNameAr': 'storeNameEn'}}"
            header="{{ 'STORE' | translate  }}"></p-column>
          <p-column field="permissionDate" [style]="{'width': '17%'}" header="{{ 'DATETIME' | translate }}"
            [sortable]="true"></p-column>
          <p-column field="{{translate.currentLang == 'ar' ? 'statusNameAr': 'statusNameEn'}}"
            header="{{'STATUS' | translate }}" [style]="{'width': '5%'}">
          </p-column>
        </p-dataTable>
      </div>
    </div> -->   <!--abdo commented for almaza -->
    <h3 *ngIf="docTransformRequests.length > 0" class="text-center text-danger font-weight-bold mt-4 mb-2">
      {{'TRANSFER_REQ' | translate}}</h3>
    <div class="row" *ngIf="docTransformRequests.length > 0">
      <div class="col">
        <p-dataTable tableStyleClass="table table-bordered table-striped" [rowStyleClass]="getCSSClasses"
          [value]="docTransformRequests" [selectionMode]="'single'" [rows]="15" [paginator]="true" [pageLinks]="3"
          [rowsPerPageOptions]="[15,20,25,30]">
          <p-column field="serial" [style]="{'width': '7%'}" header="{{ 'SERIAL' | translate  }}">
          </p-column>
          <p-column field="{{translate.currentLang == 'ar' ? 'docNameAr': 'docNameEn'}}"
            header="{{ 'DOCTOR' | translate  }}">
          </p-column>
          <p-column field="{{translate.currentLang == 'ar' ? 'expectedDocNameAr': 'expectedDocNameEn'}}"
            [style]="{'width': '15%'}" header="{{ 'EXPECTEDDOCTOR' | translate }}"></p-column>
          <p-column field="{{translate.currentLang == 'ar' ? 'placeNameAr': 'placeNameEn'}}"
            header="{{ 'PLACE' | translate  }}"></p-column>
          <p-column field="{{translate.currentLang == 'ar' ? 'specialityNameAr': 'specialityNameEn'}}"
            header="{{'SPECIALITY' | translate}}"></p-column>
          <p-column field="execDate" [style]="{'width': '17%'}" header="{{ 'DATETIME' | translate }}" [sortable]="true">
            <ng-template pTemplate="options" let-row="rowData">
              {{row['execDate'] | date:'short'}}
            </ng-template>
          </p-column>
        </p-dataTable>
      </div>
    </div>
    <h3 *ngIf="reserveTransformRequests.length > 0" class="text-center text-danger font-weight-bold mt-4 mb-2">
      {{'ADM_REQ' | translate}}</h3>
    <div class="row" *ngIf="reserveTransformRequests.length > 0">
      <div class="col">
        <p-dataTable tableStyleClass="table table-bordered table-striped" [rowStyleClass]="getCSSClasses"
          [value]="reserveTransformRequests" [selectionMode]="'single'" [rows]="15" [paginator]="true" [pageLinks]="3"
          [rowsPerPageOptions]="[15,20,25,30]">
          <p-column field="serial" [style]="{'width': '7%'}" header="{{ 'SERIAL' | translate  }}">
          </p-column>
          <p-column field="{{translate.currentLang == 'ar' ? 'docNameAr': 'docNameEn'}}"
            header="{{ 'DOCTOR' | translate  }}">
          </p-column>
          <p-column field="{{translate.currentLang == 'ar' ? 'placeFromNameAr': 'placeFromNameEn'}}"
            header="{{ 'PLACE' | translate  }}"></p-column>
          <p-column field="{{translate.currentLang == 'ar' ? 'specialityNameAr': 'specialityNameEn'}}"
            header="{{'SPECIALITY' | translate}}"></p-column>
          <p-column field="execDate" [style]="{'width': '17%'}" header="{{ 'DATETIME' | translate }}" [sortable]="true">
            <ng-template pTemplate="options" let-row="rowData">
              {{ row['execDate'] | date:'short' }}
            </ng-template>
          </p-column>

          <!-- --------حاله الطلب ----------- -->
          <p-column field="{{translate.currentLang == 'ar' ? 'orderStatusNameAr':'orderStatusNameEn'}}"
            header="{{ 'ORDERSTATUS' | translate }}"></p-column>
          <!-- ------------icon delete------------ -->
          <p-column [style]="{'width': '7%'}" header="{{ 'ACTIONS' | translate }}">
            <ng-template pTemplate="options" let-row="rowData">
              <span class="" *ngIf="row.serviceStatusCode != 5">
                <icon-action (actionclicked)="deleteRow($event,row)" [rowActiveAction]="getActiveAction" [rowData]="row"
                  [appCodes]="[304]"></icon-action>
              </span>
            </ng-template>
          </p-column>

        </p-dataTable>
      </div>
    </div>
    <h3 *ngIf="bedTransformRequests.length > 0" class="text-center text-danger font-weight-bold mt-4 mb-2">
      {{'BED_TRANSFER_REQ' | translate}}</h3>
    <div class="row" *ngIf="bedTransformRequests.length > 0">
      <div class="col">
        <p-dataTable tableStyleClass="table table-bordered table-striped" [rowStyleClass]="getCSSClasses"
          [value]="bedTransformRequests" [selectionMode]="'single'" [rows]="15" [paginator]="true" [pageLinks]="3"
          [rowsPerPageOptions]="[15,20,25,30]">
          <p-column field="serial" [style]="{'width': '7%'}" header="{{ 'SERIAL' | translate  }}">
          </p-column>
          <p-column field="{{translate.currentLang == 'ar' ? 'docNameAr': 'docNameEn'}}"
            header="{{ 'DOCTOR' | translate  }}">
          </p-column>
          <p-column field="{{translate.currentLang == 'ar' ? 'placeFromNameAr': 'placeFromNameEn'}}"
            header="{{ 'PLACE' | translate  }}"></p-column>
          <p-column field="{{translate.currentLang == 'ar' ? 'placeToNameAr': 'placeToNameEn'}}"
            header="{{ 'PLACETO' | translate  }}"></p-column>
          <p-column field="{{translate.currentLang == 'ar' ? 'specialityNameAr': 'specialityNameEn'}}"
            header="{{'SPECIALITY' | translate}}"></p-column>
          <p-column field="execDate" [style]="{'width': '17%'}" header="{{ 'DATETIME' | translate }}" [sortable]="true">
            <ng-template pTemplate="options" let-row="rowData">
              {{ row['execDate'] | date:'short' }}
            </ng-template>
          </p-column>
        </p-dataTable>
      </div>
    </div>
    <div *ngIf="showServiceStepsData">
      <h3 class="text-center text-danger font-weight-bold mt-4 mb-2">
        {{patDataService.serviceNameEn}}
        <i (click)="addNewMedicalStep()" class="fa fa-plus fa-2x"></i>
      </h3>
      <div class="row">
        <div class="col">
          <p-dataTable tableStyleClass="table table-bordered table-striped" [rowStyleClass]="getCSSClasses"
            [value]="serviceMedicalSteps" [selectionMode]="'single'" [rows]="15" [paginator]="true" [pageLinks]="3"
            [rowsPerPageOptions]="[15,20,25,30]">
            <p-column field="serial" [style]="{'width': '7%'}" header="{{ 'SERIAL' | translate  }}">
            </p-column>
            <p-column field="{{translate.currentLang == 'ar' ? 'nameAr': 'nameEn'}}"
              header="{{ 'SERVICESHAS' | translate  }}">
              <ng-template pTemplate="options" let-row="rowData">
                <span *ngIf="!row['editServiceStepRow']">
                  {{translate.currentLang == 'ar' ? row.nameAr: row.nameEn}}
                </span>

                <sanabel-selectize *ngIf="row['editServiceStepRow']" appcode="1258" [required]="true"
                  [simpleView]="true" [(ngModel)]="row.priServiceStpMedicalStepId"
                  [SearchKeys]="{ServiceCode:patientService.serviceCode}">
                </sanabel-selectize>

              </ng-template>
            </p-column>
            <p-column header="{{ 'STATUS' | translate  }}">
              <ng-template pTemplate="options" let-row="rowData">
                <input class="form-control" type="checkbox" [(ngModel)]="row['stepStatus']"
                  [disabled]="!row['editServiceStepRow']" />
              </ng-template>

            </p-column>
            <p-column field="expectedDateFormated" [style]="{'width': '17%'}" header="{{ 'EXCUTEDDATE' | translate }}"
              [sortable]="true">
              <ng-template pTemplate="options" let-row="rowData">

                <span>
                  {{ row.regDate | date : "dd/MM/yyyy" }} - {{row.empNameEn}}
                </span>
              </ng-template>
            </p-column>
            <p-column header="{{ 'ToothNo' | translate  }}">
              <ng-template pTemplate="options" let-row="rowData">
                <input class="form-control" *ngIf="row['editServiceStepRow']" type="text"
                  [(ngModel)]="row['toothNo']" />

                <span *ngIf="!row['editServiceStepRow']">
                  {{ row.toothNo}}
                </span>
              </ng-template>

            </p-column>
            <p-column header="{{ 'NOTES' | translate  }}">
              <ng-template pTemplate="options" let-row="rowData">
                <textarea class="form-control" type="string" [disabled]="!row['editServiceStepRow']"
                  [(ngModel)]="row.notes"></textarea>
              </ng-template>
            </p-column>
            <p-column [style]="{'width': '7%'}" header="{{ 'ACTIONS' | translate }}">
              <ng-template pTemplate="options" let-row="rowData">
                <span>
                  <icon-action (actionclicked)="onStepIconActionClick($event,row)" [rowActiveAction]="getActiveAction"
                    [rowData]="row" [appCodes]="[404,7075,6552]">
                  </icon-action>
                </span>
              </ng-template>
            </p-column>
          </p-dataTable>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <btns-ctrl *ngIf="editableContent" [appCodes]="[1]" (clicked)="save()"></btns-ctrl>
        </div>
      </div>
    </div>
  </div>
  <!-------------------------------------------------------------------------------->
  <div class="mt-2" *ngIf="activeAction == 637 || visitedActions['637']" [hidden]="activeAction != 637">
    <ng-container *ngIf="targetedService.hasHtmlReport">
      <ng-container *ngIf="targetedService.serviceType==2">
        <app-rad-report-write></app-rad-report-write>
      </ng-container>
      <ng-container *ngIf="targetedService.serviceType!=2">
        <app-emr-report-write [reportType]="targetedService.serviceType"></app-emr-report-write>
      </ng-container>
    </ng-container>
  </div>
  <!-------------------------------------------------------------------------------->
  <div class="row mt-3" *ngIf="activeAction == 2326 || visitedActions['2326']" [hidden]="activeAction != 2326">
    <ng-container *ngIf="targetedService.serviceType==1">
      <!-- <div class="col-3">
                <ul class="list-group">
                    <li class="list-group-item px-1 text-center" (click)="setReportvalue(service)"
                        *ngFor="let service of filteredConfirmedServices" [ngClass]="{'active' : service.status }">
                        {{ translate.currentLang =='ar'? service.serviceNameAr: service.serviceNameEn}}
                    </li>
                </ul>
            </div> -->
      <div class="col-9">
        <LabTestPrintMaster [PatService]="targetedService"></LabTestPrintMaster>
      </div>
    </ng-container>
    <ng-container *ngIf="targetedService.serviceType==2">
      <app-rad-report-print [PatService]="targetedService"></app-rad-report-print>
    </ng-container>
  </div>

  <div class="" *ngIf="activeAction == 681 || visitedActions['681']" [hidden]="activeAction != 681">
    <ng-container *ngIf="targetedService.serviceType==1">
      <app-lab-test-result [PatService]="targetedService"></app-lab-test-result>
    </ng-container>
  </div>
  <!-- <div class="" *ngIf="activeAction == 682 || visitedActions['682']" [hidden]="activeAction != 682">
        <ng-container *ngIf="targetedService.serviceType==1">
            <app-lab-test-result-review [PatService]="targetedService"></app-lab-test-result-review>
        </ng-container>
    </div> -->

  <div class="row" *ngIf="activeAction == 2325 || visitedActions['2325']" [hidden]="activeAction != 2325">
    <stock-exchange-to-outpatient></stock-exchange-to-outpatient>
  </div>
  <div class="row" *ngIf="activeAction == 689 || visitedActions['689']" [hidden]="activeAction != 689">
    <app-lab-test-charts [PatService]="targetedService"></app-lab-test-charts>
  </div>
  <div class="row" *ngIf="activeAction == 2472 || visitedActions['2472']" [hidden]="activeAction != 2472">
    <sanabel-reflux-from-outpatient></sanabel-reflux-from-outpatient>
  </div>
  <div class="container-fluid" *ngIf="activeAction == 6387 || visitedActions['6387']" [hidden]="activeAction != 6387">
    <app-service-workflow-entry [serviceType]="serviceType" [currentDetail]="currentDetail">
    </app-service-workflow-entry>
  </div>

  <div class="container-fluid" *ngIf="activeAction == 6765 || visitedActions['6765']" [hidden]="activeAction != 6765">
    <notes></notes>

  </div>
</div>
<div>
  <block-modal-container #popup (close)="onpopupClose($event)">
    <ng-container class="modal-body" [ngComponentOutlet]="dynamicComponent"></ng-container>
  </block-modal-container>
</div>
<div>

  <block-modal-container #DiscountServicesRequest (close)="onpopupClose($event)">
    <ng-container class="modal-title">
    </ng-container>
    <ng-container class="modal-body" [ngComponentOutlet]="dynamicComponent"></ng-container>
  </block-modal-container>
</div>
<div>

  <block-modal-container #EmrReportWrite (close)="onpopupClose($event)">
    <ng-container class="modal-title">
    </ng-container>
    <ng-container class="modal-body" [ngComponentOutlet]="DynamicComponent"></ng-container>
  </block-modal-container>
</div>